import { $api } from "../../../services/request.config";
import countly from "../../../../analytics/countly";
import { EVENT_NAMES } from "../../../../analytics/events";

export const sendReferenceThunkAction = (props) => async (dispatch) => {
    try {
        const temp = { ...props.currentRequest };
        delete temp.isValid;
        const response = await $api.post("v2/itsm/hr/create", temp);
        if (response.status === 200) {
            countly.event(EVENT_NAMES.SALARY_REFERENCE_REQUESTED, { pid: localStorage.getItem("pid") });
            props.closeModal(false);
            props.stateLoader(false);
            props.setErrDescription("Заявка на получение справки успешно отправлена, пожалуйста, ожидайте ее исполнения в разделе Документы");
            props.setErrorModal(true);
        }
    } catch (e) {
        props.closeModal(false);
        props.stateLoader(false);
        if (props) {
            props.setErrDescription(e?.response?.detail);
            props.setErrorModal(true);
        }
    // throw new Error("references error");
    }
};
